var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('emc-table-icon-download-base',{attrs:{"type":_vm.type,"item":_vm.item,"id":_vm.id,"color":_vm.color,"icon":_vm.icon,"tool-tip":_vm.toolTip,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }